import { cn } from "@utils/tailwind-merge"
import LoaderIcon from "@assets/icon/loader.svg?react";

interface ButtonLoaderProps {
  className?: string
}


export function ButtonLoader(props: ButtonLoaderProps){

  return <LoaderIcon className={cn("animate-spin w-5 h-5", props.className)} />
}